import * as React from 'react';
import { ErrorBoundary } from '../../utilities/global-error-boundary';
import { ICipReportIssueData } from './cip-report-issue.data';
import { ICipReportIssueProps } from './cip-report-issue.props.autogenerated';

export interface ICipReportIssueViewProps extends ICipReportIssueProps<ICipReportIssueData> {}

/**
 *
 * CipReportIssue component
 * @extends {React.PureComponent<ICipReportIssueProps<ICipReportIssueData>>}
 */
class CipReportIssue extends React.PureComponent<ICipReportIssueProps<ICipReportIssueData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default ErrorBoundary(CipReportIssue, 'cip-report-issue');
